import { toast } from "react-toastify";
import { call, put, takeLatest } from "redux-saga/effects";
import { updateProjectAdminDetails } from "../http/requests/project-admin";
import { 
  getProjectAdminData, 
  ProjectAdminType, 
  setVtrackLoader,
  hideEndDateConfirmationModal 
} from "../redux/actions";
import { toastOptions } from "../common/utils/toasterOptions";

function* workerConfirmProjectEndDateUpdateSaga({ payload }) {
  try {
    yield put(setVtrackLoader(true));
    yield call(updateProjectAdminDetails, payload.data);
    let page = payload.data.pageNo; 
    page += 1;
    let rows = payload.data.rows;
    toast.success("Project and allocations updated.", toastOptions);
    
    // Hide the confirmation modal
    yield put(hideEndDateConfirmationModal());
    
    // Refresh the project grid
    yield put(
      getProjectAdminData({
        pageNo: page,
        pageSize: rows,
        sortDir: "ASC",
        sortBy: "projectName",
        searchData: '',
        expiredAllocations: payload.data.expiredAllocations
      })
    );
    yield put(setVtrackLoader(false));
  } catch (err) {
    // Don't hide the modal on error, show the error message
    toast.error(err.data.errorMessage, toastOptions);
    yield put(setVtrackLoader(false));
  }
}

export function* confirmProjectEndDateUpdateSaga() {
  yield takeLatest(
    ProjectAdminType.CONFIRM_PROJECT_END_DATE_UPDATE,
    workerConfirmProjectEndDateUpdateSaga
  );
}
